import React from 'react'
import { withRouter } from 'react-router-dom'
import axios from 'axios'

class Forgot extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			email: ''
		}
		this.handleInputChange = this.handleInputChange.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
	}
	
	handleInputChange(event) {
		const target = event.target
		const value = target.value
		const name = target.name
		
		this.setState({
			[name]: value
		})
	}
	
	handleSubmit(e) {
		e.preventDefault()
		const { email } = this.state
		if (!email) {
			alert("Please complete all fields")
			return
		}
		let url = `http://107.170.197.5:8080/api/users/forgot/request`
		let data = JSON.stringify({
			email: email
		})
		axios.post(url, data, {headers:{'Content-Type':'application/json'}})
		.then((response) => {
			alert("An email with instructions to reset your password has been sent to: " + email)
			this.props.history.push("/")
		})
		.catch((error) => {
			return
		})
	}
	
	render() {
		return (
			<div className="rf-body">
				<div className="container">
					<form className="rf-form" onSubmit={this.handleSubmit}>
						<div className="rf-card">
							<div className="form-group">
								<label>Email</label>
								<input type="email" className="form-control" name="email" onChange={this.handleInputChange} />
								<small className="form-text text-muted">Please enter the email address associated with your account</small>
							</div>
						</div>
						<div className="rf-card">
							<button type="submit" className="btn btn-submit">Reset Password</button>
						</div>
					</form>
				</div>
			</div>
		)
	}
}

export default withRouter(Forgot)


// WEBPACK FOOTER //
// ./src/components/Reset/Forgot.js